import { createReducer, on } from '@ngrx/store';
import { setCompTableSecuritiesChoice, setFundChartSecuritiesChoice, setScatterPlotSecuritiesChoice, setTimeseriesTableSecuritiesChoice, } from './saved-asset-securities-choices.action';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setSelectedReport } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { SavedAssetSecuritiesChoice, } from '../../enums/custom-pdf-report-saved-asset-securities-choice.enum';
import { isCustomPDFReport } from 'CustomPDFReportsApp/ts/utils/custom-pdf-report-utils';
export const fundChartSecuritiesChoice = createReducer(SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY, on(setFundChartSecuritiesChoice, (state, action) => {
    return action.choice;
}), on(resetAllCustomPdfReportItems, () => {
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}), on(setSelectedReport, (state, action) => {
    const report = action.reportData;
    if (isCustomPDFReport(report)) {
        return (report.advanced_options?.fund_chart_securities_choice ||
            SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY);
    }
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}));
export const scatterPlotSecuritiesChoice = createReducer(SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY, on(setScatterPlotSecuritiesChoice, (state, action) => {
    return action.choice;
}), on(resetAllCustomPdfReportItems, () => {
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}), on(setSelectedReport, (state, action) => {
    const report = action.reportData;
    if (isCustomPDFReport(report)) {
        return (report.advanced_options?.scatter_plot_securities_choice ||
            SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY);
    }
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}));
export const compTableSecuritiesChoice = createReducer(SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY, on(setCompTableSecuritiesChoice, (state, action) => {
    return action.choice;
}), on(resetAllCustomPdfReportItems, () => {
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}), on(setSelectedReport, (state, action) => {
    const report = action.reportData;
    if (isCustomPDFReport(report)) {
        return (report.advanced_options?.comp_table_securities_choice ||
            SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY);
    }
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}));
export const timeseriesTableSecuritiesChoice = createReducer(SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY, on(setTimeseriesTableSecuritiesChoice, (state, action) => {
    return action.choice;
}), on(resetAllCustomPdfReportItems, () => {
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}), on(setSelectedReport, (state, action) => {
    const report = action.reportData;
    if (isCustomPDFReport(report)) {
        return (report.advanced_options?.timeseries_table_securities_choice ||
            SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY);
    }
    return SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY;
}));
